
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1920","height":"934","viewBox":"0 0 1920 934","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M370.9 3.07339L874.444 326.658C898.038 342.175 929.704 335.348 945.227 311.762C960.75 288.176 953.92 256.522 930.325 241.005L953.927 260.654C892.458 220.31 875.072 138.381 914.81 76.934C955.169 15.4869 1037.13 -1.89203 1098.6 37.8313L1935.19 571.696C1996.66 612.04 2014.04 693.969 1973.68 755.416C1933.33 816.863 1851.37 834.242 1789.9 794.519L1469.9 602.648C1446.3 587.131 1414.64 593.958 1399.11 617.544C1383.59 641.13 1390.42 672.784 1414.02 688.301C1498.03 747.045 1573.86 799.631 1509.69 897.505C1422.26 1030.85 1192.35 751.505 1059.19 751.505C963.188 751.505 889.826 854.016 813.688 830.505C701.471 795.853 694.108 886.666 627.188 897.505C571.909 906.458 451.531 836.13 414.188 814.005C292.688 742.019 276.188 733.505 -0.223022 571.696C-67.2805 528.248 -99.6863 451.823 -56.2231 385.411C-12.76 318.377 63.7513 318.377 130.188 361.825L166.821 385.411C190.415 399.686 370.688 514.005 394.688 462.005C418.688 410.005 360.345 377.342 336.75 361.825L195.806 269.965C121.918 221.552 100.807 122.864 149.238 49.0035C197.668 -24.2364 296.392 -45.3394 370.9 3.07339Z","fill":"white"}})])
          )
        }
      }
    